/* Project Unity homepage-only behaviour: deferred loop videos, science / explainer
   panel, outcome cards and their line tracker, learn modal and the needs rail.
   Loaded by sections/project-unity-homepage.liquid after project-unity-hero.js. */
(function () {
  /* Focus restoration lives in project-unity-core.js (loaded by the header).
     Fall back to a plain focus call if that script is missing. */
  function restoreFocus(el) {
    if (window.ProjectUnity && typeof window.ProjectUnity.restoreFocus === 'function') {
      window.ProjectUnity.restoreFocus(el);
      return;
    }
    if (!el) return;
    el.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-project-unity]').forEach(function (root) {
  if (root.dataset.puHomeReady === 'true') return;
  root.dataset.puHomeReady = 'true';
  function settleOutcomeCard(card) {
    window.setTimeout(function () {
      if (card.classList.contains('is-revealed')) card.classList.add('is-settled');
    }, 2600);
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Below-fold loops must not compete with the hero or run in hidden tabs.
  const deferredLoops = root.querySelectorAll('[data-pu-deferred-loop]');
  function updateDeferredLoop(video, visible) {
    if (!visible || reducedMotion || document.hidden) { video.pause(); return; }
    const panel = video.closest('[data-explainer-panel]');
    if (panel && panel.hidden) { video.pause(); return; }
    const source = video.querySelector('source[data-src]');
    if (source && !source.getAttribute('src')) {
      source.src = source.dataset.src;
      video.load();
    }
    const play = video.play();
    if (play && play.catch) play.catch(function () {});
  }
  if ('IntersectionObserver' in window) {
    const loopObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.dataset.puLoopVisible = String(entry.isIntersecting);
        updateDeferredLoop(entry.target, entry.isIntersecting);
      });
    }, { rootMargin: '100px', threshold: 0 });
    deferredLoops.forEach(function (video) { loopObserver.observe(video); });
    document.addEventListener('visibilitychange', function () {
      deferredLoops.forEach(function (video) {
        updateDeferredLoop(video, video.dataset.puLoopVisible === 'true');
      });
    });
  } else {
    deferredLoops.forEach(function (video) { updateDeferredLoop(video, true); });
  }

  const science = {
    hbot: {
      title: 'What is Hyperbaric Oxygen? Pressurised oxygen, absorbed by every tissue.',
      copy: 'Inside the chamber, gentle pressure allows more oxygen to dissolve into blood plasma, helping it reach tissues that ordinary circulation can struggle to supply.',
      link: '/pages/hbot-explained',
      linkLabel: 'Explore Hyperbaric Oxygen',
      heading: 'The mechanisms of action — Hyperbaric Oxygen',
      video: 'https://oxydise.co.uk/cdn/shop/videos/c/vp/4045cb5a020f4dffa338407d3707bf76/4045cb5a020f4dffa338407d3707bf76.HD-1080p-2.5Mbps-89679370.mp4',
      stats: [
        ['1.5–2.0 ATA', 'Typical operating pressure across the Oxydise range'],
        ['60–90 min', 'A typical Hyperbaric Oxygen session'],
        ['Plasma', 'Where additional oxygen is dissolved under pressure'],
        ['Guided', 'Protocol support based on your situation']
      ],
      mechanisms: [
        ['01', 'Hyperoxygenation', 'Pressure allows more oxygen to dissolve directly into blood plasma.'],
        ['02', 'Inflammatory signalling', 'Research explores how oxygen exposure may influence inflammatory pathways.'],
        ['03', 'Circulation and swelling', 'Vasoconstriction may reduce swelling while oxygen availability remains elevated.'],
        ['04', 'Repair processes', 'Oxygen is involved in collagen formation, immune activity and tissue repair.']
      ]
    },
    red: {
      title: 'What is Red Light? Specific wavelengths your cells can absorb.',
      copy: 'Red and near-infrared wavelengths are used in photobiomodulation. Research is exploring how light absorption may relate to cellular energy, circulation and recovery processes.',
      link: '/pages/red-light-explained',
      linkLabel: 'Explore Red Light Therapy',
      heading: 'The mechanisms of action — Red Light',
      video: 'https://oxydise.co.uk/cdn/shop/videos/c/vp/00d032f8757c4c1188bee9c09a32f4b9/00d032f8757c4c1188bee9c09a32f4b9.HD-1080p-7.2Mbps-88902465.mp4',
      stats: [
        ['Red light', 'Visible wavelengths used close to the skin'],
        ['Near infrared', 'Longer wavelengths used in many devices'],
        ['10–20 min', 'A common session range, depending on equipment'],
        ['Consistent', 'A repeatable routine matters more than novelty']
      ],
      mechanisms: [
        ['01', 'Light absorption', 'Specific wavelengths are absorbed by light-sensitive molecules in cells.'],
        ['02', 'Cellular energy', 'Photobiomodulation research often focuses on mitochondrial function and ATP.'],
        ['03', 'Circulation', 'Research explores how light exposure may relate to nitric oxide and local blood flow.'],
        ['04', 'Skin and recovery', 'Studies examine collagen, inflammation and local tissue-recovery processes.']
      ]
    }
  };

  const scienceTitle = root.querySelector('[data-science-title]');
  const scienceCopy = root.querySelector('[data-science-copy]');
  const scienceLink = root.querySelector('[data-science-link]');
  const scienceVideo = root.querySelector('[data-science-video]');
  const scienceStats = root.querySelector('[data-science-stats]');
  const mechanismHeading = root.querySelector('[data-mechanism-heading]');
  const mechanismGrid = root.querySelector('[data-mechanism-grid]');

  const scienceMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function scienceVideoAllowed() {
    return scienceVideo && !document.hidden && !scienceMotionPreference.matches &&
      !scienceVideo.closest('[hidden]') && scienceVideo.getClientRects().length > 0;
  }
  function stopScienceVideo() {
    if (!scienceVideo) return;
    scienceVideo.pause();
    let hadSource = scienceVideo.hasAttribute('src');
    scienceVideo.removeAttribute('src');
    scienceVideo.querySelectorAll('source').forEach(function (source) {
      hadSource = hadSource || source.hasAttribute('src');
      source.removeAttribute('src');
    });
    if (hadSource) scienceVideo.load();
  }
  if (scienceVideo) {
    scienceVideo.autoplay = false;
    scienceVideo.removeAttribute('autoplay');
    scienceVideo.preload = 'none';
    stopScienceVideo();
    const stopIneligibleScienceVideo = function () {
      if (!scienceVideoAllowed()) stopScienceVideo();
    };
    scienceVideo.addEventListener('playing', stopIneligibleScienceVideo);
    document.addEventListener('visibilitychange', stopIneligibleScienceVideo);
    if (scienceMotionPreference.addEventListener) scienceMotionPreference.addEventListener('change', stopIneligibleScienceVideo);
    else if (scienceMotionPreference.addListener) scienceMotionPreference.addListener(stopIneligibleScienceVideo);
    const scienceSection = scienceVideo.closest('.pu-science');
    if (scienceSection && 'MutationObserver' in window) {
      new MutationObserver(stopIneligibleScienceVideo).observe(scienceSection, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function renderScience(mode, requestedPlayback) {
    const item = science[mode];
    if (!item || !scienceTitle || !scienceCopy || !scienceLink || !scienceVideo || !scienceStats || !mechanismHeading || !mechanismGrid) return;
    scienceTitle.textContent = item.title;
    scienceCopy.textContent = item.copy;
    scienceLink.href = item.link;
    scienceLink.textContent = item.linkLabel;
    mechanismHeading.textContent = item.heading;
    if (!requestedPlayback || !scienceVideoAllowed()) {
      stopScienceVideo();
    } else {
      if (scienceVideo.getAttribute('src') !== item.video) {
        scienceVideo.setAttribute('src', item.video);
        scienceVideo.load();
      }
      scienceVideo.muted = true;
      scienceVideo.defaultMuted = true;
      scienceVideo.playsInline = true;
      const promise = scienceVideo.play();
      if (promise && promise.catch) promise.catch(function () {});
    }
    scienceStats.innerHTML = item.stats.map(function (stat) {
      return '<div class="pu-science__stat"><strong>' + stat[0] + '</strong><span>' + stat[1] + '</span></div>';
    }).join('');
    mechanismGrid.innerHTML = item.mechanisms.map(function (mechanism) {
      return '<article class="pu-mechanism"><span class="pu-mechanism__number">' + mechanism[0] + '</span><h4>' + mechanism[1] + '</h4><p>' + mechanism[2] + '</p><span class="pu-icon-button" aria-hidden="true">+</span></article>';
    }).join('');
  }

  /* Science, not magic: one therapy panel at a time. Both panels stay in the
     DOM so the copy is always present for search and for no-JS readers. */
  (function () {
    var group = root.querySelector('[data-explainer-group]');
    if (!group) return;
    var tabs = [].slice.call(root.querySelectorAll('[data-explainer-tab]'));
    var panels = [].slice.call(group.querySelectorAll('[data-explainer-panel]'));
    if (!tabs.length || !panels.length) return;

    /* Replay the step timeline from the top. Removing the class and forcing a
       reflow restarts the animation; without the reflow the browser coalesces
       the remove and re-add and nothing plays. */
    function runTimeline(panel) {
      var steps = panel.querySelector('.pu-explainer__steps');
      if (!steps) return;
      steps.classList.remove('is-revealed');
      void steps.offsetWidth;
      steps.classList.add('is-revealed');
    }

    function show(key, moveFocus) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.explainerTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.explainerPanel === key;
        panel.hidden = !active;
        var loop = panel.querySelector('[data-pu-deferred-loop]');
        if (loop && !active) loop.pause();
        if (!active) return;
        runTimeline(panel);
        var video = panel.querySelector('video');
        if (!video || !video.currentSrc || reducedMotion) return;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      });
    }

    if (reducedMotion || !('IntersectionObserver' in window)) {
      panels.forEach(function (panel) {
        var steps = panel.querySelector('.pu-explainer__steps');
        if (steps) steps.classList.add('is-revealed');
      });
    } else {
      var timelineObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.3) return;
          timelineObserver.unobserve(entry.target);
          entry.target.classList.add('is-revealed');
        });
      }, { threshold: [0.3] });
      panels.forEach(function (panel) {
        var steps = panel.querySelector('.pu-explainer__steps');
        if (steps) timelineObserver.observe(steps);
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { show(tab.dataset.explainerTab); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var step = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(index + step + tabs.length) % tabs.length];
        show(next.dataset.explainerTab, true);
      });
    });
  })();

  root.querySelectorAll('[data-science-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      root.querySelectorAll('[data-science-tab]').forEach(function (other) {
        const active = other === tab;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      renderScience(tab.dataset.scienceTab, true);
    });
  });
  renderScience('hbot');

  const outcomeCounters = root.querySelectorAll('[data-count-up]');
  const outcomeRows = Array.from(root.querySelectorAll('[data-outcome-card]'));
  function setCounterValue(counter, value) {
    counter.textContent = value + '%';
  }
  function animateCounter(counter) {
    if (counter.dataset.counted === 'true') return;
    counter.dataset.counted = 'true';
    const target = Number(counter.dataset.countUp) || 0;
    const duration = 1200;
    const startedAt = performance.now();

    function update(now) {
      const progress = Math.min((now - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCounterValue(counter, Math.round(target * eased));
      if (progress < 1) window.requestAnimationFrame(update);
      else setCounterValue(counter, target);
    }
    window.requestAnimationFrame(update);
  }

  if (outcomeCounters.length) {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      outcomeCounters.forEach(function (counter) {
        setCounterValue(counter, Number(counter.dataset.countUp) || 0);
      });
    } else {
      outcomeCounters.forEach(function (counter) { setCounterValue(counter, 0); });
      const counterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        });
      }, { threshold: [0.45] });
      outcomeCounters.forEach(function (counter) { counterObserver.observe(counter); });
    }
  }

  if (outcomeRows.length && !reducedMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.18) return;
        revealObserver.unobserve(entry.target);
        entry.target.classList.add('is-revealed');
        settleOutcomeCard(entry.target);
        entry.target.animate([
          { opacity: 0.45, transform: 'translateY(22px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], {
          duration: 620,
          easing: 'cubic-bezier(.22,.61,.36,1)',
          fill: 'both'
        });
      });
    }, { threshold: [0.18] });
    outcomeRows.forEach(function (row) { revealObserver.observe(row); });

    const revealVisible = function () {
      outcomeRows.forEach(function (row) {
        if (row.classList.contains('is-revealed')) return;
        const rect = row.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) { row.classList.add('is-revealed'); settleOutcomeCard(row); }
      });
    };
    window.setTimeout(revealVisible, 900);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) outcomeRows.forEach(function (row) { row.classList.add('is-revealed'); row.classList.add('is-settled'); });
    });
  } else if (outcomeRows.length) {
    outcomeRows.forEach(function (row) { row.classList.add('is-revealed'); row.classList.add('is-settled'); });
  }

  outcomeRows.forEach(function (card) {
    const graphic = card.querySelector('[data-outcome-graphic]');
    const readout = card.querySelector('[data-outcome-readout]');
    if (!graphic) return;
    const points = Array.from(graphic.querySelectorAll('[data-graphic-point]'));
    let dragging = false;
    let moved = false;
    let startX = 0;

    function clearActive() {
      points.forEach(function (point) { point.classList.remove('is-active'); });
    }

    function updateGraphic(event) {
      if (!points.length) return;
      const rect = graphic.getBoundingClientRect();
      const position = Math.max(0, Math.min(.999, (event.clientX - rect.left) / rect.width));
      const index = Math.min(points.length - 1, Math.floor(position * points.length));
      clearActive();
      points[index].classList.add('is-active');
      if (readout) {
        readout.textContent = points[index].dataset.readout || 'Explore this outcome';
      }
    }

    card.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;
      card.classList.add('is-interacting');
      updateGraphic(event);
    });
    card.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'mouse' && !dragging) return;
      if (dragging && Math.abs(event.clientX - startX) > 5) moved = true;
      updateGraphic(event);
    });
    card.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse' || dragging) return;
      card.classList.remove('is-interacting');
      clearActive();
    });
    card.addEventListener('pointerdown', function (event) {
      dragging = true;
      moved = false;
      startX = event.clientX;
      card.classList.add('is-interacting');
      card.setPointerCapture(event.pointerId);
      updateGraphic(event);
    });
    card.addEventListener('pointerup', function (event) {
      if (moved) card.dataset.skipModal = 'true';
      dragging = false;
      if (card.hasPointerCapture(event.pointerId)) card.releasePointerCapture(event.pointerId);
      if (event.pointerType !== 'mouse') window.setTimeout(function () {
        card.classList.remove('is-interacting');
        clearActive();
      }, 700);
    });
    card.addEventListener('pointercancel', function () {
      dragging = false;
      card.classList.remove('is-interacting');
      clearActive();
    });
  });

  root.querySelectorAll('[data-outcome-card]').forEach(function (card) {
    const graphic = card.querySelector('[data-outcome-graphic]');
    if (!graphic) return;
    const isLine = graphic.classList.contains('pu-outcome-card__graphic--energy')
      || graphic.classList.contains('pu-outcome-card__graphic--pain')
      || graphic.classList.contains('pu-outcome-card__graphic--stress')
      || graphic.classList.contains('pu-outcome-card__graphic--recovery');
    if (!isLine) return;
    const svg = graphic.querySelector('svg');
    const path = svg && svg.querySelector('.pu-viz__signal');
    if (!svg || !path || !svg.viewBox || !svg.viewBox.baseVal.width) return;

    const tracker = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    tracker.setAttribute('class', 'pu-viz__tracker');
    tracker.setAttribute('r', '6');
    svg.appendChild(tracker);

    let samples = null;
    function samplePath() {
      const total = path.getTotalLength();
      samples = [];
      for (let i = 0; i <= 140; i++) samples.push(path.getPointAtLength((total * i) / 140));
    }

    function restToEnd() {
      if (!samples) samplePath();
      const end = samples[samples.length - 1];
      tracker.setAttribute('cx', end.x);
      tracker.setAttribute('cy', end.y);
    }
    // Sampling the path forces style and layout; on load that cost lands on
    // the critical path for every card. The cards sit below the fold, so place
    // the tracker when each one approaches the viewport.
    if ('IntersectionObserver' in window) {
      tracker.style.visibility = 'hidden';
      const restObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        restObserver.disconnect();
        restToEnd();
        tracker.style.visibility = '';
      }, { rootMargin: '300px 0px' });
      restObserver.observe(graphic);
    } else {
      restToEnd();
    }

    const isRing = svg.classList.contains('pu-viz--ring');
    const ringReadout = card.querySelector('[data-outcome-readout]');

    function trackTo(clientX, clientY) {
      if (!samples) samplePath();
      const rect = svg.getBoundingClientRect();
      if (!rect.width) return;
      const x = ((clientX - rect.left) / rect.width) * svg.viewBox.baseVal.width;
      const y = ((clientY - rect.top) / rect.height) * svg.viewBox.baseVal.height;
      let best = samples[0];
      let bestIndex = 0;
      let bestDist = Infinity;
      for (let i = 0; i < samples.length; i++) {
        const d = isRing
          ? (samples[i].x - x) * (samples[i].x - x) + (samples[i].y - y) * (samples[i].y - y)
          : Math.abs(samples[i].x - x);
        if (d < bestDist) { bestDist = d; best = samples[i]; bestIndex = i; }
      }
      tracker.setAttribute('cx', best.x);
      tracker.setAttribute('cy', best.y);
      if (isRing && ringReadout) {
        const f = bestIndex / (samples.length - 1);
        ringReadout.textContent = f < .33 ? 'Strain after training' : f < .8 ? 'Recovery underway' : 'Back sooner';
      }
    }

    card.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'touch') return;
      card.classList.add('is-tracking');
      trackTo(event.clientX, event.clientY);
    });
    card.addEventListener('pointerleave', function () { card.classList.remove('is-tracking'); restToEnd(); });
    window.addEventListener('resize', function () { samples = null; });
  });

  const modal = root.querySelector('[data-learn-modal]');
  const modalTitle = root.querySelector('[data-modal-title]');
  const modalCopy = root.querySelector('[data-modal-copy]');
  const modalTherapy = root.querySelector('[data-modal-therapy]');
  const modalMeasured = root.querySelector('[data-modal-measured]');
  const modalMeasuredWrap = root.querySelector('[data-modal-measured-wrap]');
  const modalContextHeading = root.querySelector('[data-modal-context-heading]');
  const modalImage = root.querySelector('[data-modal-image]');
  const modalClose = root.querySelector('[data-modal-close]');
  const modalCta = root.querySelector('[data-modal-cta]');
  const modalCtaLabel = root.querySelector('[data-modal-cta-label]');
  let previousFocus = null;

  /* The chat launcher hides while a homepage modal is open. Stylesheets read that from
     this root class: an html:has(.pu-modal.is-open) check re-styled the whole page on
     every class change anywhere (INP). */
  const modalHidesLauncher = Boolean(modal && modal.matches('.pu-home .pu-modal'));

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    if (modalHidesLauncher) document.documentElement.classList.remove('pu-home-modal-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    restoreFocus(previousFocus);
  }

  root.querySelectorAll('[data-learn-card]').forEach(function (card) {
    card.addEventListener('click', function () {
      if (card.dataset.skipModal === 'true') {
        delete card.dataset.skipModal;
        return;
      }
      previousFocus = card;
      modalTitle.textContent = card.dataset.title || '';
      modalCopy.textContent = card.dataset.copy || '';
      modalTherapy.textContent = card.dataset.therapy || '';
      const modalTherapyWrap = modalTherapy.closest('.pu-modal__therapy');
      if (modalTherapyWrap) modalTherapyWrap.hidden = !card.dataset.therapy;
      const modalRole = root.querySelector('[data-modal-role]');
      if (modalRole) {
        modalRole.textContent = card.dataset.role || '';
        modalRole.hidden = !card.dataset.role;
      }
      if (modalMeasured) modalMeasured.textContent = card.dataset.measured || '';
      if (modalMeasuredWrap) modalMeasuredWrap.hidden = !card.dataset.measured;
      modalContextHeading.textContent = card.dataset.contextHeading || 'How the technology may relate';
      modalImage.style.backgroundImage = 'url("' + (card.dataset.image || '') + '")';
      modalCtaLabel.textContent = card.dataset.ctaLabel || 'Talk to the team';
      if (modalCta) modalCta.style.display = card.dataset.ctaHide === 'true' ? 'none' : '';
      modalCta.setAttribute('href', card.dataset.ctaHref || '#contact');
      modal.classList.toggle('is-outcome', card.dataset.modalStyle === 'outcome');
      modal.classList.add('is-open');
      if (modalHidesLauncher) document.documentElement.classList.add('pu-home-modal-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var modalPanel = modal.querySelector('.pu-modal__panel');
      if (modalPanel) { modalPanel.focus(); } else { modalClose.focus(); }
    });
  });

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalCta) modalCta.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal(); });
  });
})();

/* Needs rail prev/next arrows */
(function () {
  var rail = document.querySelector('[data-needs-rail]');
  var prev = document.querySelector('[data-needs-prev]');
  var next = document.querySelector('[data-needs-next]');
  if (!rail || !prev || !next) return;
  function step() {
    var card = rail.firstElementChild;
    if (!card) return rail.clientWidth;
    var styles = window.getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function update() {
    var max = rail.scrollWidth - rail.clientWidth;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max - 2;
  }
  prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  // Measuring the rail while the page is still loading forces a full layout of
  // the homepage. The rail sits below the fold, so wait until it approaches.
  if ('IntersectionObserver' in window) {
    var railObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      railObserver.disconnect();
      update();
    }, { rootMargin: '400px 0px' });
    railObserver.observe(rail);
  } else {
    window.addEventListener('load', update, { once: true });
  }
})();
